import { render, staticRenderFns } from "./3.vue?vue&type=template&id=dceaae9e&scoped=true&"
var script = {}
import style0 from "./3.vue?vue&type=style&index=0&id=dceaae9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dceaae9e",
  null
  
)

export default component.exports